import React from 'react';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { image_api, var_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import './AdvertisementMaster.css';
import slotimg from "../../images/free.png"
import Loader from '../Loader/Loader';


const AdvertisementMaster = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  const [subTypeOptions, setSubTypeOptions] = useState([]);
  const [updateSubTypeOptions, setUpdateSubTypeOptions] = useState([]);
  const [ isCreate,setCreate ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
  const ItemCodeOptions = [

    { value: 'Chef', label: 'Chef' },
    { value: 'Captain', label: 'Captain' },
    { value: 'Waiter', label: 'Waiter' },
    // Add more options as needed
  ];
  
  const [EmployeeD, setEmployeeD] = useState({});
const [formData, setFormData] = useState({
  shop_id: localStorage.getItem('ShopId'), // Populate appropriately, e.g., current shop ID
  ad_image: '', // To store the uploaded image file
  description: '',
  ad_type: '',
  type_id: '',
  external_link: '',
  is_active: 1, // Default value
});


const [updateformData, setUpdateFormData] = useState({
  shop_id: localStorage.getItem('ShopId'), // Populate appropriately, e.g., current shop ID
  ad_image: '', // To store the uploaded image file
  description: '',
  ad_type: '',
  type_id: '',
  external_link: '',
  is_active: 1, // Default value
  id:''
});
const [categories, setCategories] = useState([]);
const [subCategory, setSubCategory] = useState([]);
const [foods, setFoods] = useState([]);
const [typeOptions, setTypeOptions] = useState([]);





//change the role
  const handleCodeSelectChange = (selectedItem) => {
    console.log("selectedItem",selectedItem)
    const role = selectedItem.value
    setFormData({ ...formData, e_role: role });
  };

  
//change the shop
const handleShopSelectChange = (selectedItem) => {
  console.log("selectedItem",selectedItem)
  const role = selectedItem.value;
  setSelectedShop(role);
  fetchTables(role);
};
const handleSwitchToggle=()=> {
  // Toggle the switch state
  const newStatus = !this.state.imageStatus;
  this.setState({ imageStatus: newStatus });
  // Update localStorage
  localStorage.setItem('image_status', newStatus ? '1' : '0');
  console.log("imagestatus",localStorage.getItem('image_status'));
};
    useEffect(() => {
        fetchTables();
        // fetchShops();
      }, []);


      const fetchTables = async () => {
        setLoading(true);
        try {
          const shop_id = localStorage.getItem('ShopId');
           const response = await axios.get(`${var_api}advertisement-master/get-admin/${shop_id}`, {
            headers: { Authorization: localStorage.getItem("Token") },
          });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setTables(user);
        } catch (error) {
          setLoading(false);
          console.log(error);
          setTables([])
        }
      };


      useEffect(() => {
        if (!updateformData.ad_type) return; // Exit if ad_type is empty
        
        const shopId = localStorage.getItem('ShopId');
        const token = localStorage.getItem("Token");
        let apiUrl = "";
        if (updateformData.ad_type == 1) {
          apiUrl = `${var_api}food-master/get/${shopId}`;
        } else if (updateformData.ad_type == 2) {
          apiUrl = `${var_api}category-master/get/${shopId}`;
        } else if (updateformData.ad_type == 3) {
          apiUrl = `${var_api}sub-category-master/get/${shopId}`;
        } else {
          setUpdateSubTypeOptions([]); // Clear options
          return;
        }
    
        setLoading(true); // Start loading

        fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`, // Pass token in headers
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (!Array.isArray(data)) {
              console.error("Invalid data format: Expected an array", data);
              setUpdateSubTypeOptions([]);
              return;
          }
          setUpdateSubTypeOptions(data);
    
          if (updateformData.sub_type_name) {
            const selectedOption = data.find(
                (option) =>
                    option.food_name === updateformData.sub_type_name ||
                    option.category_name === updateformData.sub_type_name ||
                    option.sub_category_name === updateformData.sub_type_name
            );
            if (selectedOption) {
                setUpdateFormData((prev) => ({
                    ...prev,
                    type_id: selectedOption.id,
                }));
            }
        }
          })
          .catch((error) => console.error("Error fetching options:", error))
          .finally(() => setLoading(false)); // Stop loading
      }, [updateformData.ad_type]);
      
      

      const fetchShops = async () => {
        try {
           const shop = localStorage.getItem('userId')
           const response = await axios.get(`${var_api}/api/shop/data/${shop}`);
           console.log("response",response)
          const user =response.data;
          setShops(user);
          setFormData(prevState => ({
            ...prevState,
            shops: user.map(shop => ({ shop_id: shop.id, shop_name: shop.shop_name, is_active: 0 }))
          }));
        } catch (error) {
          console.log(error);
        }
      };

      const shopCodeOptions = [
        { value: 0, label: 'All' },
        ...shops.map(shop => ({
          value: shop.id,
          label: shop.shop_name
        }))
      ];
      
      

     //search the transaction data
     const filteredTables = tables?.filter((item) => {
      if (!searchQuery) return true; // If search query is empty, show all data
      const searchLower = searchQuery.toLowerCase();
      return (
        (item.ad_type_name && item.ad_type_name.toLowerCase().includes(searchLower)) ||
        (item.related_name && item.related_name.toLowerCase().includes(searchLower)) ||
        (item.external_link && item.external_link.toLowerCase().includes(searchLower)) ||
        (item.description && item.description.toLowerCase().includes(searchLower))
      );
    });
    
//handle image change
const handleImageChange = (e) => {
  setFormData((prev) => ({
    ...prev,
    ad_image: e.target.files[0], // Handle file uploads
  }));
};


//handle text field change
const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

// Handle Ad Type Change
const handleAdTypeChange = async (e) => {
  const { value } = e.target;
  setFormData((prev) => ({
    ...prev,
    ad_type: value,
    type_id: "", // Reset the selected sub-type
  }));
  const shopId = localStorage.getItem('ShopId');

  if (value === "type1") {
    // Fetch foods
    setLoading(true);
    try {
      const response = await axios.get(`${var_api}food-master/get/${shopId}`, {
        headers: { Authorization: localStorage.getItem("Token") },
      });
      setSubTypeOptions(response.data); // Update options
      console.log("fodo", response.data);
    } catch (error) {
      console.error("Error fetching foods:", error);
    } finally {
      setLoading(false);
    }
  } else if (value === "type2") {
    // Fetch categories
    setLoading(true);
    try {
      const response = await axios.get(`${var_api}category-master/get/${shopId}`, {
        headers: { Authorization: localStorage.getItem("Token") },
      });
      setSubTypeOptions(response.data); // Update options
      console.log("cate", response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  } else if (value === "type3") {
    // Fetch subcategories
    setLoading(true);
    try {
      const response = await axios.get(`${var_api}sub-category-master/get/${shopId}`, {
        headers: { Authorization: localStorage.getItem("Token") },
      });
      setSubTypeOptions(response.data); // Update options
      console.log("sub", response.data);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    } finally {
      setLoading(false);
    }
  }
   else {
    setSubTypeOptions([]); // Clear options for "External Link"
  }
};





const Submit = async (e) => {
  e.preventDefault();
  setLoading(true);
  const ad_type = formData.ad_type === "type1" ? 1 : formData.ad_type === "type2" ? 2 : formData.ad_type === "type3"  ? 3 : formData.ad_type === "type4"  ? 4 : 0;
  console.log("pso", updateformData);
  const formDataToSend = new FormData();
  formDataToSend.append('shop_id', parseInt(formData.shop_id));
  formDataToSend.append('ad_image', formData.ad_image || "-");
  formDataToSend.append('description', formData.description);
  formDataToSend.append('ad_type', ad_type);
  formDataToSend.append('type_id', formData.type_id || 0);
  formDataToSend.append('external_link', formData.external_link || "-");
  formDataToSend.append('is_active', formData.is_active);

  try {
    const token = localStorage.getItem('Token'); // Assuming token is stored in localStorage
    const response = await fetch(`${var_api}advertisement-master/post`, {
      method: 'POST',
      headers: {
        Authorization: token,
      },
      body: formDataToSend,
    });

    const result = await response.json();
    if (response.ok) {
       Swal.fire('Success', 'Advertisement created successfully!', 'success');
      setCreate(false); // Close modal
      fetchTables();
    } else {
      alert(result.error || 'Failed to create advertisement');
    }
  } catch (error) {
    console.error('Error creating advertisement:', error);
    alert('An error occurred while creating the advertisement.');
  } finally {
    setLoading(false);
  }
};

 
 // Function to handle checkbox change
 const handleCheckboxChange = (index) => {
  const updatedShops = [...formData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };

  setFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  
    //reset the values
    const handleToReset = () => {
         // Reset the form fields individually
         setFormData({
          ...formData,
          e_name: " ", 
  e_email: "", 
  e_password:" ",
  e_phone:"",
  e_role:"",
  profile:null
      });
    }

    //Go to home page
    const handleButtonClick = () => {
      history.push('/AdminHome')
    }


    //get the value in search and set the setstate
    const handleSearchInput = (e) => {
      setSearchQuery(e.target.value)
      };


      

     //delete method for remove UOM
   const handleDeleteEmployeee = (id,e_name) => {
    setShow(true);
    setEmployeeD({id:id,employee_name: e_name})
    }


    //delete the employeee
    const handleDelete = () => {
      console.log("ad+id",EmployeeD)
      const token = localStorage.getItem('Token');
      axios
      .delete(`${var_api}advertisement-master/delete/${EmployeeD.id}`, {
        headers: {
          Authorization: token,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          fetchTables();
          setShow(false);
          Swal.fire("success","Ad Removed Successfully!","success")
          // Perform any other actions you need on success
        } else if (response.status === 404) {
          console.log('Table not found');
          Swal.fire("error","Ad not found!","error")
        }
      })
      .catch((error) => {
        console.error('Error executing the request:', error);
        Swal.fire("error","Failed to Remove Ad!","error")
        // Handle the error as needed
      });
    }


    //Function for open the update modal
    const handleUpdateEmployee = (data) =>{
      setIsEdit(true);
      console.log("data",data)
      setUpdateFormData({
          id:data.id,
          ad_image: data.ad_image, 
          description: data.description, 
          shop_id: data.shop_id,
          ad_type: data.ad_type,
          type_name: data.ad_type_name,
          sub_type_name: data.related_name,
          type_id: data.type_id,
          external_link: data.external_link,
          is_active: data.is_active
      })
        // Fetch the sub-type options immediately when editing
    if (data.ad_type) {
      fetchSubTypeOptions(data.ad_type, data.related_name);
  }
    };


    // Function to fetch sub-type options and set the correct type_id
const fetchSubTypeOptions = (ad_type, sub_type_name) => {
  const shopId = localStorage.getItem('ShopId');
  const token = localStorage.getItem("Token");
  let apiUrl = "";

  if (ad_type == 1) {
      apiUrl = `${var_api}food-master/get/${shopId}`;
  } else if (ad_type == 2) {
      apiUrl = `${var_api}category-master/get/${shopId}`;
  } else if (ad_type == 3) {
      apiUrl = `${var_api}sub-category-master/get/${shopId}`;
  } else {
      setUpdateSubTypeOptions([]);
      return;
  }
  setLoading(true);

  fetch(apiUrl, {
      method: "GET",
      headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
      },
  })
  .then((response) => response.json())
  .then((data) => {
      if (!Array.isArray(data)) {
          console.error("Invalid data format:", data);
          setUpdateSubTypeOptions([]);
          return;
      }
      setUpdateSubTypeOptions(data);

      // Find the matching sub-type and set type_id
      const selectedOption = data.find(
          (option) =>
              option.food_name === sub_type_name ||
              option.category_name === sub_type_name ||
              option.sub_category_name === sub_type_name
      );
      if (selectedOption) {
          setUpdateFormData((prev) => ({
              ...prev,
              type_id: selectedOption.id,
          }));
      }
  })
  .catch((error) => console.error("Error fetching options:", error))
  .finally(()=> setLoading(false));
};


    
    const handleCreateEmployee = () =>{
      setCreate(true);
    }



    //Function for update text field onchange
    const handleInputUpdateChange = (e) => {
      const { name, value } = e.target;
      setUpdateFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    };


    const handleUpdateSubmit = async (e) => {
      e.preventDefault();
     setLoading(true);
      try {
        // const ad_type = updateformData.ad_type == "type1" ? 1 : updateformData.ad_type === "type2" ? 2 : updateformData.ad_type === "type3"  ? 3 : updateformData.ad_type === "type4"  ? 4 : 0;
        console.log("upd", updateformData);
        const formDataToSend = new FormData();
        formDataToSend.append('shop_id', parseInt(updateformData.shop_id));
        formDataToSend.append('ad_image', updateformData.ad_image || "-");
        formDataToSend.append('description', updateformData.description);
        formDataToSend.append('ad_type', parseInt(updateformData.ad_type));
        formDataToSend.append('type_id', updateformData.type_id || 0);
        formDataToSend.append('external_link', updateformData.external_link || "-");
        formDataToSend.append('is_active', updateformData.is_active);
        // formDataToSend.append('type_name', updateformData.type_name);
        // formDataToSend.append('sub_type_name', updateformData.sub_type_name);
    
        if (updateformData.profile) {
          formDataToSend.append("ad_image", updateformData.profile); // Append the file
        }
        const response = await fetch(`${var_api}advertisement-master/put/${updateformData.id}`, {
          method: "PUT",
          headers: {
            Authorization:  localStorage.getItem("Token"), // Example token handling
          },
          body: formDataToSend, // Send FormData
        });
    
        if (response.ok) {
          const data = await response.json();
          alert("Advertisement updated successfully!");
          setIsEdit(false); // Close modal
          fetchTables();
        } else {
          const errorData = await response.json();
          alert(errorData.error || "Failed to update advertisement");
        }
      } catch (error) {
        console.error("Error updating advertisement:", error);
        alert("An error occurred while updating advertisement");
      }finally{
        setLoading(false);
      }
    };



//Oncahnge function for update role
const handleRoleUpdateChange = (selectedOption) => {
  console.log("hjdahj",selectedOption.value)
  setUpdateFormData({ ...updateformData, e_role: selectedOption.value});
};

//onchange function for file 
const handleImageUpdateChange = (e) => {
  const file = e.target.files[0];
  console.log("file",file)
  setUpdateFormData({ ...updateformData, profile: file });
};


 // Function to handle update checkbox change
 const handleUpdateCheckboxChange = (index) => {
  const updatedShops = [...updateformData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };
  console.log("upd",updatedShops);

  setUpdateFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};



  const data = [
    { id: 1, image: slotimg, type: "Food", subtype: "f1", description: "Food item 1" },
    { id: 2, image: slotimg, type: "Food", subtype: "f2", description: "Food item 2" },
    { id: 3, image: slotimg, type: "Category", subtype: "c1", description: "Category item 1" },
    { id: 4, image: slotimg, type: "Category", subtype: "c2", description: "Category item 2" },
    { id: 5, image: slotimg, type: "Sub-Category", subtype: "sc1", description: "Sub-category item 1" },
    { id: 6, image: slotimg, type: "Sub-Category", subtype: "sc2", description: "Sub-category item 2" },
    { id: 7, image: slotimg, type: "External Link", subtype: "https://example.com/1", description: "External link 1" },
    { id: 8, image: slotimg, type: "External Link", subtype: "https://example.com/2", description: "External link 2" },
    { id: 9, image: slotimg, type: "Food", subtype: "f3", description: "Food item 3" },
    { id: 10, image: slotimg, type: "Category", subtype: "c3", description: "Category item 3" },
  ];
  


    return(
      <>         <Layout>

        {/* <div className='whole' style={{backgroundColor:"white"}}> */}
            {/* <div class="split left">
                <div class="centered">
                    <h3 className='ushe'>EMPLOYEE MASTER</h3>
                    <div style={{marginLeft:"12px",padding:"12px"}}>

                    <form onSubmit={Submit}>
                        <div class="form-floating mb-3" style={{width:"350px",margin:"auto"}}>
                            <input type="text" class="form-control" id="floatingInput" placeholder="name" name='e_name' value={formData.e_name} onChange={handleInputChange}  style={{borderRadius:"15px",height:"50px"}} required/>
                            <label for="floatingInput">Employee Name</label>
                        </div>
                        <div class="form-floating mb-3" style={{width:"350px",margin:"auto"}}>
                            <input type="email" class="form-control" id="floatingInput" placeholder="name@example.com" name='e_email' value={formData.e_email} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required/>
                            <label for="floatingInput">Email Address</label>
                        </div>
                        <div class="form-floating mb-3" style={{width:"350px",margin:"auto"}}>
                            <input type="text" class="form-control" id="floatingInput" placeholder="password" name='e_password' value={formData.e_password} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required />
                            <label for="floatingInput">password</label>
                        </div>
                        <div class="form-floating mb-3" style={{width:"350px",margin:"auto"}}>
                            <input type="number" class="form-control" id="floatingInput" placeholder="phone" name='e_phone' value={formData.e_phone} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required/>
                            <label for="floatingInput">Phone No</label>
                        </div>
                        <div class="form-floating mb-3" style={{width:"350px",margin:"auto",zIndex:"2"}}>
                        <Select
                        options={ItemCodeOptions}
                        placeholder="Select Role"
                        onChange={handleCodeSelectChange}
                        isSearchable={true}
                        className="customSelect mb-3"
                        styles={{
                          // Styles for increasing width and height
                          control: (provided, state) => ({
                            ...provided,
                            width: '350px', // Adjust width as needed
                            minHeight: '50px', // Adjust height as needed
                            borderRadius: '15px'
                          }),
                        }}
                         />
                         </div>

                         <div class="card mb-3" style={{width: "22rem",margin:"auto",height:"10rem",borderRadius:"15px",border:"none",overflowX:"scroll",zIndex:"1"}}>
                          <div class="card-body">
                            <h5 class="card-title" style={{fontSize:"14px",color:"green"}}>Select Shop</h5>
                            {formData.shops.map((shop, index) => (
        <div className="form-check" key={index}>
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id={`flexCheckDefault_${index}`}
            onChange={() => handleCheckboxChange(index)}
            checked={shop.is_active === 1}
          />
          <label className="form-check-label" htmlFor={`flexCheckDefault_${index}`}>{shop.shop_name}</label>
        </div>
      ))}   
                           
                          </div>
                         </div>

                        <div class="form-floating mb-3" style={{width:"350px",margin:"auto"}}>
                            <input type="file" class="form-control" id="formFile" onChange={handleImageChange} name='profile'  style={{borderRadius:"15px",height:"50px"}} />
                        </div>
                        a
                        <div class="text-center">
          {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
        ) : (
          <button className='btn btn-success' style={{float:"right"}} disabled={postloading}>Create Employee</button>
        )}
        </div>       
            </form>
            
            <button className='btn btn-secondary' style={{float:"right",marginRight:"3px"}} onClick={handleToReset} >Reset</button> {' '}
                       
                        
                    </div>
                   
                </div>
            </div> */}

            <div class="splitsc">
              {loading && <Loader />}
          
      <div style={{border:"none",padding:"20px",width:"100%",height:"auto",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>    
    {/* <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"18px",float:"right",borderRadius:"15px"}}>Create Slot</Button>{' '} */}
    
    <div>
  
   
     <div class="row">
     <div class="col">
         <h4 className='ushe'>ADVERTISEMENT MASTER</h4>
         </div>
         <div class="col">
       <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Ads</Button>{' '}
       <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
       </div>
     </div>
      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll' }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"90%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Image</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Type</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Type Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Description</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
    </tr>
  </thead>
  <tbody class="body-half-screen">
   {/* {filteredSuppliers && filteredSuppliers.length > 0 ? (
   filteredSuppliers && filteredSuppliers.map((data,index) =>( */}

{filteredTables.map((item, index) => (
        <tr key={item.id} style={{ padding: "4px" }}>
          <th scope="row">{index + 1}</th>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>
            <img src={`${image_api}/${item.ad_image}`} alt="profile" width="35px" height="30px" />
          </td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.ad_type_name}</td>
          <td style={{ textAlign: "left" }}>{item.related_name ? item.related_name : item.external_link}</td>
          <td style={{ textAlign: "left" }}>{item.description}</td>
          <td style={{ textAlign: "left" }}>
          <i class="bi bi-pencil-square" onClick={()=>handleUpdateEmployee(item)}  style={{fontSize:"20px",color:"rgb(9, 97, 9)"}}></i>{' '}
          <i class="bi bi-trash" onClick={()=>handleDeleteEmployeee(item.id, item.ad_type_name)} style={{fontSize:"21px",color:"rgb(175, 2, 2)"}}></i>
          </td>
        </tr>
      ))}
   {/* ))
   ) : (
    <tr>
      <td colSpan="6" style={{ textAlign: "center", color:"red", fontWeight:"bold", borderColor:"black" }}>
        Slot Not Found
      </td>
    </tr>
   )} */}
 

   </tbody>

</table>

      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Ads 
          <span style={{color:"red",textTransform:"uppercase"}}> {EmployeeD.employee_name}</span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

      <Modal
        show={isEdit}
        onHide={()=>setIsEdit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Advertisement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={handleUpdateSubmit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Upload Image</label>
              <input type="file" class="form-control" placeholder="Upload Image" id="input1"  name="ad_image"  onChange={handleImageUpdateChange}  style={{borderRadius:"12px"}}/>
            </div>
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Description{" "}</label>
              <input type="text" class="form-control" id="updatedescription"  name='description'  style={{borderRadius:"12px"}} value={updateformData.description} onChange={handleInputUpdateChange}/>
            </div>
          </div>
          <br/>
          <div class="row">
          <div class="col">
            <label
              htmlFor="ad_type"
              style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
            >
              Select Type
            </label>
            <div style={{ position: "relative" }}>
            <select
      className="form-control"
      id="typeOptions"
      name="ad_type"
      value={`type${updateformData.ad_type}`} // Controlled input
      onChange={(e) =>
        setUpdateFormData({
          ...updateformData,
          ad_type: e.target.value.replace("type", ""), // Store only numeric value
        })
      }
      style={{ borderRadius: "12px" }}
      required
    >
       <option value="">Select</option>
              <option value="type1">Food</option>
              <option value="type2">Category</option>
              <option value="type3">Sub Category</option>
              <option value="type4">External Link</option>
    </select>
            <i
        className="bi bi-chevron-down"
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none",
          color: "gray",
        }}
      ></i>
      </div>
            </div>
            <div className="col">
            {updateformData.ad_type != 4 && (
             <div>
               <label
              htmlFor="externalLink"
              style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
            >
              Sub-type
            </label>
  <select
    className="form-control"
    id="subTypeOptions"
    name="type_id"
    value={updateformData.type_id} // Controlled input
    // onChange={handleInputUpdateChange}
    onChange={(e) =>
      setUpdateFormData({ ...updateformData, type_id: e.target.value })
    }
    style={{ borderRadius: "12px" }}
    required
  >
    <option value="">Select sub-type</option>
    {updateSubTypeOptions?.map?.((option) => (
      <option key={option.id} value={option.id}>
        {updateformData.ad_type == 1 && option.food_name}
        {updateformData.ad_type == 2 && option.category_name}
        {updateformData.ad_type == 3 && option.sub_category_name}
      </option>
    ))}
  </select>
             </div>
)}

          {/* External Link (Only if ad_type is type4) */}
          {updateformData.ad_type == 4 && (
            <div>
              <label
                htmlFor="externalLink"
                style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
              >
                External Link
              </label>
              <input
                type="text"
                className="form-control"
                id="externalLink"
                name="external_link"
                style={{ borderRadius: "12px" }}
                value={updateformData.external_link || ""}
                onChange={handleInputUpdateChange}
                placeholder="Enter external link"
                required
              />
            </div>
          )}
        </div>

            {/* </div> */}
          </div>
          <br/>
          <button className="btn btn-success" style={{float:"right",margin:"5px",borderRadius:"15px"}}>Update</button>
          </form>
          <button className="btn btn-danger" onClick={()=>setIsEdit(false)} style={{borderRadius:"15px",float:"right",marginTop:"-1px"}}>Cancel</button>
        </Modal.Body>  <Modal
        show={isEdit}
        onHide={()=>setIsEdit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Advertisement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={handleUpdateSubmit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Upload Image</label>
              <input type="file" class="form-control" placeholder="Upload Image" id="input1"  name="ad_image"  onChange={handleImageUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Description{" "}</label>
              <input type="text" class="form-control" id="updatedescription"  name='description'  style={{borderRadius:"12px"}} value={updateformData.description} onChange={handleInputUpdateChange}/>
            </div>
          </div>
          <br/>
          <div class="row">
          <div class="col">
            <label
              htmlFor="ad_type"
              style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
            >
              Select Type
            </label>
            <div style={{ position: "relative" }}>
            <select
      className="form-control"
      id="typeOptions"
      name="ad_type"
      value={`type${updateformData.ad_type}`} // Controlled input
      onChange={(e) =>
        setUpdateFormData({
          ...updateformData,
          ad_type: e.target.value.replace("type", ""), // Store only numeric value
        })
      }
      style={{ borderRadius: "12px" }}
      required
    >
       <option value="">Select</option>
              <option value="type1">Food</option>
              <option value="type2">Category</option>
              <option value="type3">Sub Category</option>
              <option value="type4">External Link</option>
    </select>
            <i
        className="bi bi-chevron-down"
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none",
          color: "gray",
        }}
      ></i>
      </div>
            </div>
            <div className="col">
            {updateformData.ad_type != 4 && (
             <div>
               <label
              htmlFor="externalLink"
              style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
            >
              Sub-type
            </label>
  <select
    className="form-control"
    id="subTypeOptions"
    name="type_id"
    value={updateformData.type_id} // Controlled input
    // onChange={handleInputUpdateChange}
    onChange={(e) =>
      setUpdateFormData({ ...updateformData, type_id: e.target.value })
    }
    style={{ borderRadius: "12px" }}
    required
  >
    <option value="">Select sub-type</option>
    {updateSubTypeOptions?.map?.((option) => (
      <option key={option.id} value={option.id}>
        {updateformData.ad_type == 1 && option.food_name}
        {updateformData.ad_type == 2 && option.category_name}
        {updateformData.ad_type == 3 && option.sub_category_name}
      </option>
    ))}
  </select>
             </div>
)}

          {/* External Link (Only if ad_type is type4) */}
          {updateformData.ad_type == 4 && (
            <div>
              <label
                htmlFor="externalLink"
                style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
              >
                External Link
              </label>
              <input
                type="text"
                className="form-control"
                id="externalLink"
                name="external_link"
                style={{ borderRadius: "12px" }}
                value={updateformData.external_link || ""}
                onChange={handleInputUpdateChange}
                placeholder="Enter external link"
                required
              />
            </div>
          )}
        </div>

            {/* </div> */}
          </div>
          <br/>
          <button className="btn btn-success" style={{float:"right",margin:"5px",borderRadius:"15px"}}>Update</button>
          </form>
          <button className="btn btn-danger" onClick={()=>setIsEdit(false)} style={{borderRadius:"15px",float:"right",marginTop:"-1px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 
      </Modal> 

      <Modal
        show={isCreate}
        onHide={()=>setCreate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Create Advertisement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={Submit}>
        <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Upload Image</label>
              <input type="file" class="form-control" placeholder="Upload Image" id="input1" onChange={handleImageChange}  style={{borderRadius:"12px"}} required={formData.ad_type != "type4"}/>
            </div>
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Description{" "}</label>
              <input type="text" class="form-control" id="inputDescription"  name='description'  style={{borderRadius:"12px"}} value={formData.description} onChange={handleInputChange} required />
            </div>
          </div>
          <br/>
          <div class="row">
          <div class="col">
            <label
              htmlFor="slotSelect"
              style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
            >
              Select Type
            </label>
            <div style={{ position: "relative" }}>
            <select
              class="form-control"
              id="slotSelect"
              name="ad_type"
              value={formData.ad_type}
              onChange={handleAdTypeChange}
              style={{ borderRadius: "12px" }}
              required
            >
            <option value="">Select type</option>
            <option value="type1">Food</option>
            <option value="type2">Category</option>
            <option value="type3">Sub Category</option>
            <option value="type4">External Link</option>
            </select>
            <i
        className="bi bi-chevron-down"
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none",
          color: "gray",
        }}
      ></i></div>
            </div>
            <div class="col">
              {/*need multi select option */}
              {formData.ad_type !== "type4" && (
          <div>
            <label
              htmlFor="subTypeSelect"
              style={{ color: 'green', fontFamily: 'serif', fontWeight: 'bolder' }}
            >
              Select Sub-Type
            </label>
            <div style={{ position: "relative" }}>
            <select
  className="form-control"
  id="subTypeSelect"
  name="type_id"
  value={formData.type_id}
  onChange={handleInputChange}
  style={{ borderRadius: "12px" }}
  required
>
  <option value="">Select sub-type</option>
  {subTypeOptions.map((option) => (
     <option key={option.id} value={option.id}>
     {formData.ad_type === "type1" && option.food_name}
     {formData.ad_type === "type2" && option.category_name}
     {formData.ad_type === "type3" && option.sub_category_name}
   </option>
  ))}
</select>

            <i
        className="bi bi-chevron-down"
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none",
          color: "gray",
        }}
      ></i></div>
          </div>
        )}
         {/* Conditional rendering for External Link input field */}
      {formData.ad_type === 'type4' && (
          <div>
            <label
              htmlFor="externalLink"
              style={{ color: 'green', fontFamily: 'serif', fontWeight: 'bolder' }}
            >
              External Link
            </label>
            <input
              type="text"
              className="form-control"
              id="externalLink"
              name="external_link"
              style={{ borderRadius: '12px' }}
              value={formData.external_link} // Controlled input
              onChange={handleInputChange} // General text field handling
              placeholder="Enter external link"
            />
          </div>
      )}
      </div>

            {/* </div> */}
          </div>
         <br/>
         <div class="text-center">
          {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
        ) : (
          <button className='btn btn-success' style={{borderRadius:"15px",float:"right",marginTop:"6px"}} disabled={postloading}>Create</button>
        )}
        </div>           </form>
          <button className="btn btn-danger" onClick={()=>setCreate(false)} style={{borderRadius:"15px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 


            {/* </div> */}
       </Layout></>

        
    )
}

export default AdvertisementMaster;